import { Brand, Schema } from '@blade/std-lib'

export const ZeroSlotApiKeyTypeId = 'tradebot-tma/ZeroSlotApiKey'
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type ZeroSlotApiKeyTypeId = typeof ZeroSlotApiKeyTypeId

export type ZeroSlotApiKey = Brand.Branded<string, ZeroSlotApiKeyTypeId>
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ZeroSlotApiKey = Brand.nominal<ZeroSlotApiKey>()

export const ZeroSlotApiKeySchema = Schema.String.pipe(
  Schema.fromBrand(ZeroSlotApiKeyTypeId, ZeroSlotApiKey),
)
